"use client";

import React from "react";
import { m as motion } from "framer-motion";
import { usePrefersReducedMotion } from "@/lib/performance-hooks";

export const SectionDivider = React.memo(() => {
  const prefersReducedMotion = usePrefersReducedMotion();

  return (
    <div className="relative w-full h-px flex items-center justify-center transform-gpu">
      <motion.div
        initial={{ scaleX: 0 }}
        whileInView={{ scaleX: 1 }}
        viewport={{ once: true }}
        transition={{
          duration: prefersReducedMotion ? 0 : 0.8,
          ease: "easeInOut",
        }}
        className="absolute w-full h-[2px] bg-gradient-to-r from-transparent via-border to-transparent opacity-60 backface-visibility-hidden transform-gpu"
      />
      <motion.div
        initial={{ scale: 0 }}
        whileInView={{ scale: 1 }}
        viewport={{ once: true }}
        transition={{
          duration: prefersReducedMotion ? 0 : 0.5,
          delay: prefersReducedMotion ? 0 : 0.3,
        }}
        className="absolute left-1/2 top-1/2 -ml-1.5 -mt-1.5 w-3 h-3 rounded-full bg-primary/60 shadow-lg shadow-primary/30 backface-visibility-hidden transform-gpu"
      />
    </div>
  );
});

SectionDivider.displayName = "SectionDivider";
